module.exports = __webpack_public_path__ + "img/shengdan-pop.c79d0d7d.png";